import { CONSTANTS } from './styles';
import { FlatListItems } from './types';

const getRowType = (data: FlatListItems = [], index = 0) => {
  const fieldType = data[index].category.custom_fields.find(field => field.field_value);

  return fieldType?.field_value || 'shortform';
};

export const getRowPosition = (index: number, data: FlatListItems) => {
  let offset = 0;

  for (let current_index = 0; current_index < index; current_index++) {
    const rowType = getRowType(data, current_index);
    const rowHeight = CONSTANTS[rowType].TILE_HEIGHT;

    offset += rowHeight + CONSTANTS.rowTitleHeight + CONSTANTS.rowSpacing + CONSTANTS.rowTitleSpacing;
  }

  const thisRowType = getRowType(data, index);
  const thisRowTileHeight = CONSTANTS[thisRowType].TILE_HEIGHT;
  const thisRowHeight = thisRowTileHeight + CONSTANTS.rowTitleHeight + CONSTANTS.rowSpacing + CONSTANTS.rowTitleSpacing;

  return {
    length: thisRowHeight,
    offset,
    index,
  };
};
